<div class="page-logo shadow-bottom" [class.d-inline-block]="isDeeplink" [class.w-auto]="isDeeplink">
    <img
        class="logo-max-height"
        [class.margin-top-10]="isDeeplink"
        [src]="logo && logo.size ? (logo | fileToBase64 | async) : env.logo"
        alt="{{ env.appName }}"
        aria-roledescription="logo"
    />
</div>
